import { numberTest, percentTest, resultThrow } from "@ixfx/guards";
import { getPointParameter } from "./get-points-parameter.js";
import { length } from "./length.js";
import { reverse } from "./reverse.js";
/**
 * Calculates a point in-between a line's start and end points.
 *
 * @param amount Interpolation amount
 * @param aOrLine Line, or first point
 * @param pointBOrAllowOverflow Second point (if needed) or allowOverflow.
 * @param allowOverflow If true, interpolation amount is permitted to exceed 0..1, extending the line.
 * @returns
 */
export function interpolate(amount, aOrLine, pointBOrAllowOverflow, allowOverflow) {
    if (typeof pointBOrAllowOverflow === `boolean`) {
        allowOverflow = pointBOrAllowOverflow;
        pointBOrAllowOverflow = undefined;
    }
    if (!allowOverflow)
        resultThrow(percentTest(amount, `amount`));
    else
        resultThrow(numberTest(amount, ``, `amount`));
    const [a, b] = getPointParameter(aOrLine, pointBOrAllowOverflow);
    const d = length(a, b);
    const d2 = d * (1 - amount);
    // Points are identical, return a copy of b
    if (d === 0 && d2 === 0)
        return Object.freeze({ ...b });
    const x = b.x - (d2 * (b.x - a.x) / d);
    const y = b.y - (d2 * (b.y - a.y) / d);
    return Object.freeze({
        ...b,
        x: x,
        y: y
    });
}
/**
 * Returns the point along a line from its start (A)
 * @param line Line
 * @param distance Distance
 * @param fromA If _true_ (default) returns from A. Use _false_ to calculate from end
 * @returns
 */
export function pointAtDistance(line, distance, fromA = true) {
    if (!fromA)
        line = reverse(line);
    const dx = line.b.x - line.a.x;
    const dy = line.b.y - line.a.y;
    const theta = Math.atan2(dy, dx);
    const xp = distance * Math.cos(theta);
    const yp = distance * Math.sin(theta);
    return { x: xp + line.a.x, y: yp + line.a.y };
}
